module.exports = __webpack_public_path__ + "img/t_0019.2c62bc82.gif";